import { useQuery } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';
import type { RoleSearchCondition } from '../types/role';

/**
 * GET /api/eraf/roles — 역할 목록 조회 (페이징/검색/필터/정렬)
 * queryKey: ['role-management', 'list', filters]
 */
export function useRoleList(filters: RoleSearchCondition) {
  return useQuery({
    queryKey: ['role-management', 'list', filters],
    queryFn: () => roleApi.list(filters),
    staleTime: 30_000,
  });
}
